import { Alert } from '@mui/material';

const FormError = ({ errorMessage }) => {

    return (
        <Alert severity="error" variant='filled' sx={{ my: 2, mb: 1, border: 'none' }}>
            {errorMessage}
        </Alert>
    );
};

export default FormError;
